const nav = navigator as Navigator & {
	userAgentData?: { mobile?: boolean };
};

export function getDeviceType(): "mobile" | "tablet" | "desktop" {
	if (nav.userAgentData && typeof nav.userAgentData.mobile === "boolean") {
		if (nav.userAgentData.mobile === false) return "desktop";
	}

	const ua = (navigator.userAgent || navigator.vendor || (window as any).opera).toLowerCase();

	const isAndroid = /android/i.test(ua);
	const isTablet =
		/ipad|tablet|nexus 7|nexus 10|sm-t|kindle|silk|playbook/i.test(ua) || (isAndroid && !/mobile/i.test(ua));

	const isMobile = !isTablet && /iphone|ipod|android.*mobile|blackberry|iemobile|opera mini/i.test(ua);

	if (isTablet) return "tablet";
	if (isMobile) return "mobile";
	return "desktop";
}

export function isMobile(): boolean {
	return getDeviceType() === "mobile";
}

export function isTablet(): boolean {
	return getDeviceType() === "tablet";
}

export function isDesktop(): boolean {
	return getDeviceType() === "desktop";
}

export function isTouchDevice(): boolean {
	return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
